import { FC, useEffect, useRef, useState } from 'react'

export interface StepCarouselProps {
  current: string
  steps: Array<{
    id: string
    step: JSX.Element
  }>
}

const FADE_MS = 150

export const StepCarousel: FC<StepCarouselProps> = ({ steps, current }) => {
  const [displayedId, setDisplayedId] = useState(current)
  const [opacity, setOpacity] = useState(1)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (current === displayedId) return

    if (timerRef.current) clearTimeout(timerRef.current)

    setOpacity(0)
    timerRef.current = setTimeout(() => {
      setDisplayedId(current)
      setOpacity(1)
      window.scrollTo(0, 0)
    }, FADE_MS)

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [current])

  const step = steps.find(({ id }) => id === displayedId)

  return (
    <div style={{ transition: `opacity ${FADE_MS}ms ease`, opacity }}>
      {step && <div key={displayedId}>{step.step}</div>}
    </div>
  )
}
